module.exports = __webpack_public_path__ + "img/调拨.836ec360.svg";